<div class="section-one-line-item row enclose-line-item-block">
  <div class="section-1 w-10">{{ productItem.lineNumber }}</div>
  <div class="section-2 w-25">
    <label class="line-item-heading">
      {{ "orderTracking.partNoDescLbl" | cxTranslate }}
    </label>
    <div class="line-item-desc">
      {{ productItem?.partNumber }}
    </div>
    <div class="line-item-desc mt-1">
      <a
        matTooltipClass="vs-tooltip"
        [matTooltip]="productItem?.description"
        class="vs-product-name"
        [innerHTML]="productItem?.description"
      ></a>
    </div>
  </div>
  <div class="section-3 w-25">
    <label class="line-item-heading">{{
      "orderTracking.quantityLbl" | cxTranslate
    }}</label>
    <div class="line-item-desc">
      {{ productItem?.qty }} {{ productItem?.uom }}
    </div>
  </div>
  <div class="section-4 w-25 item-status">
    <div class="line-item-heading">
      {{ "orderTracking.status" | cxTranslate }}
    </div>
    <span
      [ngStyle]="{
        'background-color': fetchOrderStatusColor(productItem?.status)
      }"
      class="item-status status-label"
      >{{ fetchOrderStatus(productItem?.status) }}</span
    >
  </div>
  <div class="section-5 w-10">
    <em
      *ngIf="productOpen"
      (click)="toggleProduct()"
      class="material-icons move-right"
      >keyboard_arrow_up</em
    >
    <em
      *ngIf="!productOpen"
      (click)="toggleProduct()"
      class="material-icons move-right"
      >keyboard_arrow_down</em
    >
  </div>
</div>

<div
  class="row d-flex justify-content-around margin-top-1"
  *ngIf="!productOpen"
>
  <div class="section-1 w-10"><span class="space-empty">&nbsp;</span></div>
  <div class="section-2 custom-left-padding-3 w-25">
    <label class="line-item-heading">{{
      "orderTracking.requestDateLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc">{{ productItem?.reqShipDate }}</span>
  </div>
  <div class="section-4 custom-left-padding-1 w-25">
    <span class="space-empty">&nbsp;</span>
  </div>
  <div class="section-5 w-10"></div>
</div>

<div class="row d-flex justify-content-around margin-top-1" *ngIf="productOpen">
  <div class="section-1 w-10"><span class="space-empty">&nbsp;</span></div>
  <div class="section-2 custom-left-padding-3 w-25"></div>
  <div class="section-3 custom-left-padding-5 w-25">
    <label class="line-item-heading">{{
      "orderTracking.unitPriceLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc"
      >{{ productItem?.currency }}{{ getNetPrice(productItem?.unitPrice, productItem?.currency) }}</span
    >
    <a
      *ngIf="
        productItem?.discountValues?.length ||
        productItem?.priceAdderData?.length
      "
      (click)="this.breakUp = !this.breakUp"
      class="arw detail-view"
      >{{"orderTracking.viewDetails" | cxTranslate}}
      <i *ngIf="!breakUp" class="material-icons">keyboard_arrow_down</i>
      <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i></a
    >
  </div>

  <div class="section-4 custom-left-padding-4 w-25">
    <!-- <label class="line-item-heading">{{
      "orderTracking.requestDateLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc">{{ productItem?.reqShipDate }}</span> -->
  </div>
  
  <div class="section-5 w-10"><span class="space-empty">&nbsp;</span></div>
</div>

<div
  class="row d-flex justify-content-around margin-top-1"
  *ngIf="
    productOpen && productItem?.status.toLowerCase().indexOf('shipped') == -1
  "
>
  <div class="section-1 w-10"><span class="space-empty">&nbsp;</span></div>
  <div class="section-2 custom-left-padding-6 w-25">
    <label class="line-item-heading">{{
      "orderTracking.shipSetLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc">{{ productItem?.deliveryGroupNumber }}</span>
  </div>
  <div class="section-3 custom-left-padding-5 w-25">
    <label class="line-item-heading">{{
      "orderTracking.extendDateLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc"
      >{{ productItem?.currency }}{{ getNetPrice(productItem?.netPrice, productItem?.currency) }}</span
    >
  </div>
  <div class="section-4 custom-left-padding-4 w-25">
    <label class="line-item-heading">{{
      "orderTracking.currentPromiseDate" | cxTranslate
    }}</label>
    <span *ngIf="productItem.orderStatus != 'Shipped & Invoiced'" class="line-item-desc">{{productItem.geFromDate }} </span>
    <span *ngIf="productItem.orderStatus == 'Shipped & Invoiced'" class="line-item-desc">{{productItem.actShpDate }} </span>
  </div>
  <div class="section-5 w-10"><span class="space-empty">&nbsp;</span></div>
</div>

<div
  class="row d-flex justify-content-around margin-top-1"
  *ngIf="
    productOpen && productItem?.status.toLowerCase().indexOf('shipped') != -1
  "
>
  <div class="section-1 w-10"><span class="space-empty">&nbsp;</span></div>
  <div class="section-2 custom-left-padding-3 w-25">
    <label class="line-item-heading">{{
      "orderTracking.carrierLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc">{{ productItem?.courier }}</span>
  </div>
  <div class="section-3 custom-left-padding-2 w-25">
    <label class="line-item-heading">{{
      "orderTracking.extendDateLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc"
      >{{ productItem?.currency }}{{ getNetPrice(productItem?.netPrice, productItem?.currency) }}</span
    >
  </div>
  <div class="section-4 custom-left-padding-1 w-25">
    <label class="line-item-heading">{{
      "orderTracking.currentPromiseDate" | cxTranslate
    }}</label>
    <span *ngIf="productItem.orderStatus != 'Shipped & Invoiced'" class="line-item-desc">{{productItem.geFromDate }} </span>
    <span *ngIf="productItem.orderStatus == 'Shipped & Invoiced'" class="line-item-desc">{{productItem.actShpDate }} </span>
  </div>
  <div class="section-5 w-10"><span class="space-empty">&nbsp;</span></div>
</div>

<div
  class="row d-flex justify-content-around margin-top-1"
  *ngIf="
    productOpen && productItem.status.toLowerCase().indexOf('shipped') != -1
  "
>
  <div class="section-1 w-10"><span class="space-empty">&nbsp;</span></div>
  <div class="section-2 custom-left-padding-3 w-25">
    <label class="line-item-heading">{{
      "orderTracking.trackingNoLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc">{{ productItem?.trackingNumber }}</span>
  </div>
  <div class="section-3 custom-left-padding-2 w-25">
    <label class="line-item-heading">{{
      "orderTracking.shipSetLbl" | cxTranslate
    }}</label>
    <span class="line-item-desc">{{ productItem?.deliveryGroupNumber }}</span>
  </div>
  <div class="section-4 custom-left-padding-1 w-25"></div>
  <div class="section-5 w-10"><span class="space-empty">&nbsp;</span></div>
</div>

<div
  class="breakup-dropdown"
  *ngIf="breakUp"
  (clickOutside)="closeMenu($event)"
  [exclude]="'a,.arw'"
>
  <div class="row list-price-row m-0">
    <span class="price-menu-heading bold col-6">{{"orderTracking.listPrice" | cxTranslate}}</span>
    <span class="price-menu-content bold col-6"
      >{{ productItem?.currency }} {{ getNetPrice(productItem?.listPrice, productItem?.currency) }}</span
    >
  </div>
  <div
    class="row discounts"
    *ngFor="let discounts of productItem?.discountValues"
  >
    <span class="price-menu-heading col-6">{{
      getDiscountName(discounts.code)
    }}</span>
    <span class="price-menu-content col-2"
      >{{ discounts.appliedValue | number: "1.0-0" }}%</span
    >
    <span class="price-menu-content col-4"
      >{{ discounts.currency }} -{{ discounts.formattedValue }}</span
    >
  </div>
  <div
    class="row discounts"
    *ngFor="let discounts of productItem?.priceAdderData"
  >
    <span class="price-menu-heading col-6">{{
      getDiscountName(discounts.code)
    }}</span>
    <span class="price-menu-content col-2"
      >{{ discounts.appliedValue | number: "1.0-0" }}%</span
    >
    <span class="price-menu-content col-4"
      >{{ discounts.currency }} {{ discounts.formattedValue }}</span
    >
  </div>
  <div
    class="row total-discounts"
    *ngIf="
      productItem?.discountValues?.length > 0 ||
      productItem?.priceAdderData?.length > 0
    "
  >
    <span class="price-menu-heading col-6">{{"orderTracking.totalAdjustment" | cxTranslate}}</span>
    <span class="price-menu-content col-6"
      >{{ productItem?.currency }}
      {{
        getTotalDiscounts(
          productItem?.discountValues,
          productItem?.priceAdderData
        )
      }}</span
    >
  </div>

  <div class="row net-price">
    <span class="price-menu-heading bold col-6">{{"orderTracking.netPriceHeader" | cxTranslate}}</span>
    <span class="price-menu-content bold col-6"
      >{{ productItem?.currency }} {{ getNetPrice(productItem?.netPrice, productItem?.currency) }}</span
    >
  </div>
</div>
<div class="row bdr-btm"></div>
